import { Directive, ElementRef, Input, OnDestroy, Renderer2 } from '@angular/core';
import { TourService } from './tour.service';

@Directive({
  selector: '[tourTarget]'
})
/**
 * This directive is used to register a tour target element.
 * @example
 * <div tourTarget tourId="tour-1" stepId="step-1" position="right"></div>
 * position can be 'right', 'left', 'top', 'bottom' with an optional modifyer asfter "-"  'right', 'left', 'top', 'bottom', or a number.
 * If a number is used, the number is used as the offset from the top of the  left or right element or form the left of a top or bottom element.
 * If 'center' is used, the offset is half the element's height/width.
 * If 'left' is used, the offset is 0.
 * If 'right' is used, the offset is the element's width.
 * If 'top' is used, the offset is 0.
 * If 'bottom' is used, the offset is the element's height.
 */
export class TourTargetDirective implements OnDestroy {
  constructor(private el: ElementRef, private renderer: Renderer2, private tourService: TourService) { }
  private _tourId: string;
  private _stepId: string;
  private _position: string = 'right';

  @Input() set tourId(value: string) {
    this._tourId = value;
  }

  @Input() set stepId(value: string) {
    this._stepId = value;
  }
  /**
   * position can be 'right', 'left', 'top', 'bottom' with an optional modifier asfter "-"  'right', 'left', 'top', 'bottom', or a number.
   * If a number is used, the number is used as the offset from the top of the  left or right element or form the left of a top or bottom element.
   * If 'center' is used, the offset is half the element's height/width.
   * If 'left' is used, the offset is 0.
   * If 'right' is used, the offset is the element's width.
   * If 'top' is used, the offset is 0.
   * If 'bottom' is used, the offset is the element's height.
   */
  @Input() set tourPosition(value: string) {
    this._position = value; 
  }

  setup() {
    if (this._tourId && this._stepId) {
      let tours = this._tourId.split(',');
      let steps = this._stepId.split(',');
      let positions = this._position.split(',');
      tours.forEach((tour, index) => {
        this.tourService.registerTourStep(tour, steps[index], this.el, positions[index]);
      });
    }
  }

  ngAfterViewInit() {
    this.setup();
  }

  ngOnDestroy() {
    if (this._tourId && this._stepId) {
      this.tourService.removeTourElement(this._tourId, this._stepId);
    }
  }
}


